export default [
  {
    path: '/join-us',
    name: 'join-us',
    component: () => import('@/views/other/JoinUsView.vue')
  },{
    path: '/bd',
    name: 'business-development',
    component: () => import('@/views/other/BdView.vue')
  },{
    path: '/tch-tutor/:id',
    name: 'tch-tutor',
    component: () => import('@/views/other/TutorView.vue'),
  },
];